export const DURATION_MS = 7000;

export const SEGMENTS_GAP = 8;
